"use client";

import React from "react";
import { useCart } from "@/src/contexts/CartContext";

const inr = (n: number) => "₹" + n.toLocaleString("en-IN");

/**
 * Real free-delivery progress nudge, driven by the live cart subtotal vs the
 * outlet's free-delivery threshold. Renders nothing when no threshold is set.
 */
export function FreeDeliveryNudge({
  threshold,
  className = "",
}: {
  threshold?: number | null;
  className?: string;
}) {
  const { getTotal } = useCart();
  if (!threshold || threshold <= 0) return null;

  const subtotal = getTotal();
  const unlocked = subtotal >= threshold;
  const remaining = Math.max(0, threshold - subtotal);
  const progress = Math.min(100, Math.round((subtotal / threshold) * 100));

  return (
    <div
      className={`rounded-2xl p-4 ${className}`}
      style={{ background: "var(--surface)", border: "1px solid var(--border-soft)", boxShadow: "var(--shadow-soft)" }}
    >
      <div className="flex items-center justify-between gap-3 text-[13px]">
        <span className="flex items-center gap-2 font-semibold" style={{ color: unlocked ? "var(--navy)" : "var(--techno-black)" }}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={unlocked ? "var(--navy)" : "var(--coral)"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1.5" y="6" width="12" height="10" rx="1.5" /><path d="M13.5 9H17l4 4v3h-7.5z" /><circle cx="6" cy="18.5" r="1.6" /><circle cx="18" cy="18.5" r="1.6" />
          </svg>
          {unlocked ? "Free delivery unlocked" : <>You&apos;re <strong style={{ color: "var(--coral-deep)" }}>{inr(remaining)}</strong> away from free delivery</>}
        </span>
        <span style={{ color: "var(--techno-black-50)", fontFamily: "var(--font-display)", fontWeight: 600 }}>{inr(subtotal)} / {inr(threshold)}</span>
      </div>
      <div className="mt-2.5 h-2 w-full overflow-hidden rounded-full" style={{ background: "var(--cream)" }}>
        <div className="h-full rounded-full transition-all" style={{ width: `${progress}%`, background: unlocked ? "var(--navy)" : "var(--coral)" }} />
      </div>
    </div>
  );
}
